import { useState, useEffect } from 'react';

const translations = {
  es: {
    title: 'Colombia investiga',
    subtitle: 'Tejiendo redes de acceso abierto al conocimiento colombiano',
    searchTitle: 'Repositorios institucionales colombianos',
    searchSubtitle: 'Acceso al conocimiento académico y científico de forma abierta y gratuita',
    placeholder: 'Buscar institución o universidad...',
    noResults: 'No se encontraron repositorios para "{searchTerm}"',
    showList: 'Ver lista alfabética',
    hideList: 'Ocultar lista',
    listTitle: 'Lista completa de repositorios institucionales',
    repositories: 'Repositorios',
    researchers: 'Investigadores/as',
    departments: 'Departamentos',
    openAccess: 'Acceso abierto',
    registered: 'institucionales registrados',
    connected: 'conectados en red',
    covered: 'cubiertos en Colombia',
    knowledge: 'y conocimiento libre',
    copyright: '© 2026, Alfredo Menéndez',
    footerSubtitle: 'Tejiendo redes de acceso abierto al conocimiento colombiano',
    footerDescription: 'Plataforma diseñada para facilitar el acceso a repositorios institucionales colombianos',
    followUs: 'Síguenos en TikTok',
    footerAppBy: 'Una aplicación de',
    'loading.title': 'Colombia investiga',
    'loading.subtitle': 'Tejiendo redes de acceso abierto al conocimiento colombiano',
    'language.es': 'Español',
    'language.en': 'English',
    'language.pt': 'Português',
    'language.fr': 'Français',
    'language.de': 'Deutsch',
    'language.it': 'Italiano',
    'language.zh': '中文',
    'language.ja': '日本語',
    'language.ko': '한국어',
    'language.pl': 'Polski',
    'language.ro': 'Română',
    'language.ru': 'Русский',
    'language.hi': 'हिन्दी'
  },
  en: {
    title: 'Colombia investigates',
    subtitle: 'Weaving networks of open access to Colombian knowledge',
    searchTitle: 'Colombian institutional repositories',
    searchSubtitle: 'Open and free access to academic and scientific knowledge',
    placeholder: 'Search institution or university...',
    noResults: 'No repositories found for "{searchTerm}"',
    showList: 'Show alphabetical list',
    hideList: 'Hide list',
    listTitle: 'Complete list of institutional repositories',
    repositories: 'Repositories',
    researchers: 'Researchers',
    departments: 'Departments',
    openAccess: 'Open Access',
    registered: 'registered institutional',
    connected: 'connected in network',
    covered: 'covered in Colombia',
    knowledge: 'and free knowledge',
    copyright: '© 2026, Alfredo Menéndez',
    footerSubtitle: 'Weaving networks of open access to Colombian knowledge',
    footerDescription: 'Platform designed to facilitate access to Colombian institutional repositories',
    followUs: 'Follow us on TikTok',
    footerAppBy: 'An application by',
    'loading.title': 'Colombia investigates',
    'loading.subtitle': 'Weaving networks of open access to Colombian knowledge'
  },
  pt: {
    title: 'Colômbia investiga',
    subtitle: 'Tecendo redes de acesso aberto ao conhecimento colombiano',
    footerAppBy: 'Um aplicativo de',
    searchTitle: 'Repositórios institucionais colombianos',
    searchSubtitle: 'Acesso aberto e gratuito ao conhecimento acadêmico e científico',
    placeholder: 'Buscar instituição ou universidade...',
    noResults: 'Nenhum repositório encontrado para "{searchTerm}"',
    showList: 'Ver lista alfabética',
    hideList: 'Ocultar lista',
    listTitle: 'Lista completa de repositórios institucionais',
    repositories: 'Repositórios',
    researchers: 'Pesquisadores',
    departments: 'Departamentos',
    openAccess: 'Acesso aberto',
    registered: 'institucionais registrados',
    connected: 'conectados em rede',
    covered: 'cobertos na Colômbia',
    knowledge: 'e conhecimento livre',
    copyright: '© 2026, Alfredo Menéndez',
    footerSubtitle: 'Tecendo redes de acesso aberto ao conhecimento colombiano',
    footerDescription: 'Plataforma projetada para facilitar o acesso aos repositórios institucionais colombianos',
    followUs: 'Siga-nos no TikTok',
    'loading.title': 'Colômbia investiga',
    'loading.subtitle': 'Tecendo redes de acesso aberto ao conhecimento colombiano'
  },
  fr: {
    title: 'La Colombie enquête',
    subtitle: 'Tisser des réseaux d\'accès ouvert aux connaissances colombiennes',
    footerAppBy: 'Une application de',
    searchTitle: 'Dépôts institutionnels colombiens',
    searchSubtitle: 'Accès libre et gratuit aux connaissances académiques et scientifiques',
    placeholder: 'Rechercher une institution ou une université...',
    noResults: 'Aucun dépôt trouvé pour "{searchTerm}"',
    showList: 'Voir la liste alphabétique',
    hideList: 'Masquer la liste',
    listTitle: 'Liste complète des dépôts institutionnels',
    repositories: 'Dépôts',
    researchers: 'Chercheurs',
    departments: 'Départements',
    openAccess: 'Accès ouvert',
    registered: 'institutionnels enregistrés',
    connected: 'connectés en réseau',
    covered: 'couverts en Colombie',
    knowledge: 'et savoir libre',
    copyright: '© 2026, Alfredo Menéndez',
    footerSubtitle: 'Tisser des réseaux d\'accès ouvert aux connaissances colombiennes',
    footerDescription: 'Plateforme conçue pour faciliter l\'accès aux dépôts institutionnels colombiens',
    followUs: 'Suivez-nous sur TikTok',
    'loading.title': 'La Colombie enquête',
    'loading.subtitle': 'Tisser des réseaux d\'accès ouvert aux connaissances colombiennes'
  },
  de: {
    title: 'Kolumbien forscht',
    subtitle: 'Netzwerke für freien Zugang zu kolumbianischem Wissen knüpfen',
    footerAppBy: 'Eine Anwendung von',
    searchTitle: 'Kolumbianische institutionelle Repositorien',
    searchSubtitle: 'Offener und kostenloser Zugang zu akademischem und wissenschaftlichem Wissen',
    placeholder: 'Institution oder Universität suchen...',
    noResults: 'Keine Repositorien für "{searchTerm}" gefunden',
    showList: 'Alphabetische Liste anzeigen',
    hideList: 'Liste ausblenden',
    listTitle: 'Vollständige Liste der institutionellen Repositorien',
    repositories: 'Repositorien',
    researchers: 'Forscher',
    departments: 'Abteilungen',
    openAccess: 'Freier Zugang',
    registered: 'registrierte Institutionen',
    connected: 'vernetzt',
    covered: 'in Kolumbien abgedeckt',
    knowledge: 'und freies Wissen',
    copyright: '© 2026, Alfredo Menéndez',
    footerSubtitle: 'Netzwerke für freien Zugang zu kolumbianischem Wissen knüpfen',
    footerDescription: 'Plattform für den Zugang zu kolumbianischen institutionellen Repositorien',
    followUs: 'Folgen Sie uns auf TikTok',
    'loading.title': 'Kolumbien forscht',
    'loading.subtitle': 'Netzwerke für freien Zugang zu kolumbianischem Wissen knüpfen'
  },
  it: {
    title: 'La Colombia indaga',
    subtitle: 'Tessendo reti di accesso aperto alla conoscenza colombiana',
    footerAppBy: 'Un\'applicazione di',
    searchTitle: 'Repository istituzionali colombiani',
    searchSubtitle: 'Accesso aperto e gratuito alla conoscenza accademica e scientifica',
    placeholder: 'Cerca istituzione o università...',
    noResults: 'Nessun repository trovato per "{searchTerm}"',
    showList: 'Mostra elenco alfabetico',
    hideList: 'Nascondi elenco',
    listTitle: 'Elenco completo dei repository istituzionali',
    repositories: 'Repository',
    researchers: 'Ricercatori',
    departments: 'Dipartimenti',
    openAccess: 'Accesso aperto',
    registered: 'istituzionali registrati',
    connected: 'connessi in rete',
    covered: 'coperti in Colombia',
    knowledge: 'e conocimiento libera',
    copyright: '© 2026, Alfredo Menéndez',
    footerSubtitle: 'Tessendo reti di accesso aperto alla conocimiento colombiana',
    footerDescription: 'Piattaforma progettata para facilitare l\'accesso ai repository istituzionali colombiani',
    followUs: 'Seguici su TikTok',
    'loading.title': 'La Colombia indaga',
    'loading.subtitle': 'Tessendo reti di accesso aperto alla conocimiento colombiana'
  },
  zh: {
    title: '哥伦比亚调查',
    subtitle: '编织哥伦比亚知识开放获取网络',
    footerAppBy: '应用程序来自',
    searchTitle: '哥伦比亚机构知识库',
    searchSubtitle: '公开免费获取学术和科学知识',
    placeholder: '搜索机构或大学...',
    noResults: '未找到 "{searchTerm}" 的知识库',
    showList: '查看字母列表',
    hideList: '隐藏列表',
    listTitle: '机构知识库完整列表',
    repositories: '知识库',
    researchers: '研究人员',
    departments: '部门',
    openAccess: '开放获取',
    registered: '注册机构',
    connected: '网络连接',
    covered: '覆盖哥伦比亚',
    knowledge: '和自由知识',
    copyright: '© 2026, Alfredo Menéndez',
    footerSubtitle: '编织哥伦比亚知识开放获取网络',
    footerDescription: '旨在促进访问哥伦比亚机构知识库的平台',
    followUs: '在 TikTok 上关注我们',
    'loading.title': '哥伦比亚调查',
    'loading.subtitle': '编织哥伦比亚知识开放获取网络'
  },
  ja: {
    title: 'コロンビア調査',
    subtitle: 'コロンビアの知識へのオープンアクセスのネットワークを編む',
    footerAppBy: 'のアプリケーション',
    searchTitle: 'コロンビアの機関リポジトリ',
    searchSubtitle: '学術的および科学的知識へのオープンで無料のアクセス',
    placeholder: '機関または大学を検索...',
    noResults: '"{searchTerm}" のリポジトリが見つかりませんでした',
    showList: 'アルファベット順リストを表示',
    hideList: 'リストを隠す',
    listTitle: '機関リポジトリの完全なリスト',
    repositories: 'リポジトリ',
    researchers: '研究者',
    departments: '県',
    openAccess: 'オープンアクセス',
    registered: '登録機関',
    connected: 'ネットワーク接続',
    covered: 'コロンビア全土をカバー',
    knowledge: 'と自由な知識',
    copyright: '© 2026, Alfredo Menéndez',
    footerSubtitle: 'コロンビアの知識へのオープンアクセスのネットワークを編む',
    footerDescription: 'コロンビアの機関リポジトリへのアクセスを容易にするために設計されたプラットフォーム',
    followUs: 'TikTokでフォローする',
    'loading.title': 'コロンビア調査',
    'loading.subtitle': 'コロンビアの知識へのオープンアクセスのネットワークを編む'
  },
  ko: {
    title: '콜롬비아 조사',
    subtitle: '콜롬비아 지식에 대한 오픈 액세스 네트워크 구축',
    footerAppBy: '의 애플리케이션',
    searchTitle: '콜롬비아 기관 리포지토리',
    searchSubtitle: '학술 및 과학 지식에 대한 공개적이고 무료적인 접근',
    placeholder: '기관 또는 대학 검색...',
    noResults: '"{searchTerm}"에 대한 리포지토리를 찾을 수 없습니다',
    showList: '알파벳순 목록 보기',
    hideList: '목록 숨기기',
    listTitle: '기관 리포지토리 전체 목록',
    repositories: '리포지토리',
    researchers: '연구원',
    departments: '부서',
    openAccess: '오픈 액세스',
    registered: '등록된 기관',
    connected: '네트워크 연결',
    covered: '콜롬비아 전역 보장',
    knowledge: '및 자유 지식',
    copyright: '© 2026, Alfredo Menéndez',
    footerSubtitle: '콜롬비아 지식에 대한 오픈 액세스 네트워크 구축',
    footerDescription: '콜롬비아 기관 리포지토리 접근을 용이하게 하기 위해 설계된 플랫폼',
    followUs: 'TikTok에서 팔로우하세요',
    'loading.title': '콜롬비아 조사',
    'loading.subtitle': '콜롬비아 지식에 대한 오픈 액세스 네트워크 구축'
  },
  pl: {
    title: 'Kolumbia bada',
    subtitle: 'Tworzenie sieci otwartego dostępu do kolumbijskiej wiedzy',
    footerAppBy: 'Aplikacja stworzona przez',
    searchTitle: 'Kolumbijskie repozytoria instytucjonalne',
    searchSubtitle: 'Otwarty i bezpłatny dostęp do wiedzy akademickiej i naukowej',
    placeholder: 'Szukaj instytucji lub uniwersytetu...',
    noResults: 'Nie znaleziono repozytoriów dla "{searchTerm}"',
    showList: 'Pokaż listę alfabetyczną',
    hideList: 'Ukryj listę',
    listTitle: 'Pełna lista repozytoriów instytucjonalnych',
    repositories: 'Repozytoria',
    researchers: 'Badacze',
    departments: 'Departamenty',
    openAccess: 'Otwarty dostęp',
    registered: 'zarejestrowane instytucje',
    connected: 'połączone w sieć',
    covered: 'objęte w Kolumbii',
    knowledge: 'i wolna wiedza',
    copyright: '© 2026, Alfredo Menéndez',
    footerSubtitle: 'Tworzenie sieci otwartego dostępu do kolumbijskiej wiedzy',
    footerDescription: 'Platforma zaprojektowana w celu ułatwienia dostępu do kolumbijskich repozytoriów instytucjonalnych',
    followUs: 'Śledź nas na TikTok',
    'loading.title': 'Kolumbia bada',
    'loading.subtitle': 'Tworzenie sieci otwartego dostępu do kolumbijskiej wiedzy'
  },
  ro: {
    title: 'Columbia investighează',
    subtitle: 'Țesând rețele de acces deschis la cunoștințele columbiene',
    footerAppBy: 'O aplicație de',
    searchTitle: 'Depozite instituționale columbiene',
    searchSubtitle: 'Acces deschis și gratuit la cunoștințele academice și științifice',
    placeholder: 'Căutați instituția sau universitatea...',
    noResults: 'Nu s-au găsit depozite pentru "{searchTerm}"',
    showList: 'Vezi lista alfabetică',
    hideList: 'Ascunde lista',
    listTitle: 'Lista completă a depozitelor instituționale',
    repositories: 'Depozite',
    researchers: 'Cercetători',
    departments: 'Departamente',
    openAccess: 'Acces deschis',
    registered: 'instituții înregistrate',
    connected: 'conectate în rețea',
    covered: 'acoperite în Columbia',
    knowledge: 'și cunoaștere liberă',
    copyright: '© 2026, Alfredo Menéndez',
    footerSubtitle: 'Țesând rețele de acces deschis la cunoștințele columbiene',
    footerDescription: 'Platformă concepută pentru a facilita accesul la depozitele instituționale columbiene',
    followUs: 'Urmăriți-ne pe TikTok',
    'loading.title': 'Columbia investighează',
    'loading.subtitle': 'Țesând rețele de acces deschis la cunoștințele columbiene'
  },
  ru: {
    title: 'Колумбия исследует',
    subtitle: 'Плетение сетей открытого доступа к колумбийским знаниям',
    footerAppBy: 'Приложение от',
    searchTitle: 'Колумбийские институциональные репозитории',
    searchSubtitle: 'Открытый и бесплатный доступ к академическим и научным знаниям',
    placeholder: 'Поиск учреждения или университета...',
    noResults: 'Репозитории для "{searchTerm}" не найдены',
    showList: 'Показать алфавитный список',
    hideList: 'Скрыть список',
    listTitle: 'Полный список институциональных репозиториев',
    repositories: 'Репозитории',
    researchers: 'Исследователи',
    departments: 'Департаменты',
    openAccess: 'Открытый доступ',
    registered: 'зарегистрированные организации',
    connected: 'соединены в сеть',
    covered: 'охвачено в Колумбии',
    knowledge: 'и свободные знания',
    copyright: '© 2026, Альфредо Менендес',
    footerSubtitle: 'Плетение сетей открытого доступа к колумбийским знаниям',
    footerDescription: 'Платформа для облегчения доступа к колумбийским институциональным репозиториям',
    followUs: 'Подписывайтесь на нас в TikTok',
    'loading.title': 'Колумбия исследует',
    'loading.subtitle': 'Плетение сетей открытого доступа к колумбийским знаниям'
  },
  hi: {
    title: 'कोलंबिया जांच',
    subtitle: 'कोलंबियाई ज्ञान तक खुली पहुंच का नेटवर्क बुनना',
    footerAppBy: 'द्वारा एक एप्लिकेशन',
    searchTitle: 'कोलंबियाई संस्थागत भंडार',
    searchSubtitle: 'अकादमिक और वैज्ञानिक ज्ञान तक खुली और मुफ्त पहुंच',
    placeholder: 'संस्था या विश्वविद्यालय खोजें...',
    noResults: '"{searchTerm}" के लिए कोई भंडार नहीं मिला',
    showList: 'वर्णमाला सूची देखें',
    hideList: 'सूची छिपाएं',
    listTitle: 'संस्थागत भंडारों की पूरी सूची',
    repositories: 'भंडार',
    researchers: 'शोधकर्ता',
    departments: 'विभाग',
    openAccess: 'खुली पहुंच',
    registered: 'पंजीकृत संस्थान',
    connected: 'नेटवर्क से जुड़े',
    covered: 'कोलंबिया में कवर किया गया',
    knowledge: 'और मुफ्त ज्ञान',
    copyright: '© 2026, अल्फ्रेडो मेनेंडेज़',
    footerSubtitle: 'कोलंबियाई ज्ञान तक खुली पहुंच का नेटवर्क बुनना',
    footerDescription: 'कोलंबियाई संस्थागत भंडारों तक पहुंच की सुविधा के लिए डिज़ाइन किया गया मंच',
    followUs: 'टिकटॉक पर हमें फॉलो करें',
    'loading.title': 'कोलंबिया जांच',
    'loading.subtitle': 'कोलंबियाई ज्ञान तक खुली पहुंच का नेटवर्क बुनना'
  }
};

const useLanguage = () => {
  const [language, setLanguage] = useState(() => {
    const stored = localStorage.getItem('colombia-investiga-language');
    return stored || 'es';
  });

  useEffect(() => {
    localStorage.setItem('colombia-investiga-language', language);
  }, [language]);

  const t = (key, params = {}) => {
    const value = translations[language]?.[key] || translations['es']?.[key];
    if (typeof value === 'string' && Object.keys(params).length > 0) {
      return value.replace(/\{(\w+)\}/g, (match, param) => params[param] || match);
    }
    return value || key;
  };

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    window.location.reload();
  };

  const languages = [
    { code: 'es', name: t('language.es'), flag: '🇨🇴' },
    { code: 'en', name: t('language.en'), flag: '🇬🇧' },
    { code: 'pt', name: t('language.pt'), flag: '🇧🇷' },
    { code: 'fr', name: t('language.fr'), flag: '🇫🇷' },
    { code: 'de', name: t('language.de'), flag: '🇩🇪' },
    { code: 'it', name: t('language.it'), flag: '🇮🇹' },
    { code: 'zh', name: t('language.zh'), flag: '🇨🇳' },
    { code: 'ja', name: t('language.ja'), flag: '🇯🇵' },
    { code: 'ko', name: t('language.ko'), flag: '🇰🇷' },
    { code: 'pl', name: t('language.pl'), flag: '🇵🇱' },
    { code: 'ro', name: t('language.ro'), flag: '🇷🇴' },
    { code: 'ru', name: t('language.ru'), flag: '🇷🇺' },
    { code: 'hi', name: t('language.hi'), flag: '🇮🇳' }
  ];

  return { language, t, changeLanguage, languages };
};

export default useLanguage;